import api from "./api";

export interface PlatformStats {
  total_files: number;
  indexed_files: number;
  total_chats: number;
  total_users: number;
  total_projects: number;
}

export function getPlatformStats(): Promise<PlatformStats> {
  return api.get<PlatformStats>("/platform/stats");
}
